<template>
  <mask-page>
    <div class="customer-dialog">
      <i class="el-icon-arrow-left" @click="goLeft"></i>
      <div class="customer-dialog-box">
        <div class="left-name">{{ nowCompany.name }}</div>
        <div style="letter-spacing: 2px; line-height: 25px" v-html="nowIntro">
          {{ nowIntro }}
        </div>
      </div>
      <div class="right-img-box">
        <div
          class="right-img flex-c-cc"
          v-for="(i, index) in nowList"
          :key="index"
          @click="onCompany(i)"
        >
          <img class="img-item" :src="i.url" />
          <div v-if="i.sort != nowCompany.sort" class="img-mask"></div>
        </div>
      </div>
      <i class="el-icon-arrow-right" @click="goRight"></i>
      <i class="el-icon-close" @click="onClose"></i>
    </div>
  </mask-page>
</template>

<script>
import marked from 'marked'
export default {
  name: 'customer-dialog',
  props: ['item', 'list'],
  data() {
    return {
      nowIntro: this.item.intro,
      nowCompany: [],
      nowList: this.list,
    }
  },
  watch: {
    nowCompany(now, pre) {
      this.nowCompany = now
      this.nowIntro = marked(this.nowCompany.intro)
    },
    item: {
      handler(now) {
        this.nowList = [
          now,
          ...this.list.filter((item) => {
            return now.name != item.name
          }),
        ].map((item, index) => {
          return { ...item, sort: index }
        })
        this.nowCompany = this.nowList[0]
        this.nowIntro = marked(this.nowCompany.intro)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onCompany(item) {
      this.nowCompany = item
    },
    goLeft() {
      let sort = this.nowCompany.sort
      if (sort >= 1) {
        this.nowCompany = this.nowList[sort - 1]
        this.nowIntro = marked(this.nowCompany.intro)
      }
    },
    goRight() {
      let sort = this.nowCompany.sort
      if (sort < this.nowList.length - 1) {
        this.nowCompany = this.nowList[sort + 1]
        this.nowIntro = marked(this.nowCompany.intro)
      }
    },
  },
}
</script>

<style lang='scss' >
.customer-dialog {
  width: 940px;
  height: 680px;
  margin: auto;
  margin-top: 100px;
  z-index: 100;
  display: flex;
  position: relative;
  color: #222;
  font-size: 14px;
  .customer-dialog-box {
    background: #fff;
    padding: 20px;
    width: 680px;
    height: 520px;
    overflow-y: auto;
    border: 3px solid #fff;
    img {
      width: 600px !important;
    }
    .left-name {
      font-size: 24px;
      font-weight: 340;
    }
    .left-img {
      padding: 10px 0;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
    }
    &::-webkit-scrollbar {
      width: 8px;
      height: 12px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      &:hover {
        background-color: #999;
      }
    }
  }
  .right-img-box {
    width: 200px;
    height: 520px;
    overflow-y: scroll;
    cursor: pointer;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      color: transparent;
      display: none;
    }
    .right-img {
      margin-left: 5px;
      height: 100px;
      position: relative;
      background-color: #fff;
      margin-bottom: 5px;
      display: grid;
      .img-item {
        max-width: 120px;
        max-height: 50px;
        margin: auto;
      }
      .img-mask {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }
  .el-icon-arrow-left,
  .el-icon-arrow-right {
    cursor: pointer;
    font-size: 35px;
    color: #fff;
    background-color: #272727;
    height: 55px;
    padding: 10px 0;
    margin: auto 10px;
    margin-bottom: 370px;
  }

  .el-icon-close {
    position: absolute;
    right: 15px;
    font-size: 30px;
    cursor: pointer;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customer-dialog.vue